import gql from "graphql-tag";

export const MY_HR_GET_WORKING_PLACES = gql`
  query workingPlaces(
    $searchField: String
    $searchText: String
    $sort: String
    $page: Int
    $pageSize: Int
    $workingPlaces: [String]
    $product: String
    $role: String
    $showAllowedEntities: Boolean
  ) {
    workingPlaces(
      searchField: $searchField
      searchText: $searchText
      sort: $sort
      page: $page
      pageSize: $pageSize
      workingPlaces: $workingPlaces
      product: $product
      role: $role
      showAllowedEntities: $showAllowedEntities
    ) {
      availableList {
        _id
        code
        name
      }
      selectedList {
        _id
        code
        name
      }
      total
      page
      pageSize
      totalPages
    }
  }
`;
